import React, { useContext } from 'react';
import { ICustomersContext, CustomersContext } from '../../../customersState/customersContext';
import Text from 'components/Text/Text';
import { Item } from './Item';
import classNames from 'classnames';
import style from './index.module.scss';

export const DeletedCustomersList: React.FC = () => {
	const { customers } = useContext<ICustomersContext>(CustomersContext);

	const nameHeadingClasses = classNames(style.name, style.heading);
	const deletingDateHeadingClasses = classNames(style.deletingDate, style.heading);
	const userHeadingClasses = classNames(style.user, style.heading);

	return (
		<div className={style.container} data-test="DeletedCustomersList">
			<div className={style.tableHeaders}>
				<Text
					className={nameHeadingClasses}
					translationNameSpace="listing"
					translationKey="nameLabel"
					withTooltip={true}
					isNewTooltip={true}
				/>
				<Text
					className={deletingDateHeadingClasses}
					translationNameSpace="listing"
					translationKey="deletingDateLabel"
					withTooltip={true}
					isNewTooltip={true}
				/>
				<Text
					className={userHeadingClasses}
					translationNameSpace="listing"
					translationKey="userLabel"
					withTooltip={true}
					isNewTooltip={true}
				/>
			</div>
			{customers.customers.map((item, index) => (
				<Item data={item} key={item.id} index={index} />
			))}
		</div>
	);
};
